import { frontendURL } from '../../../helper/URLHelper';

export const routes = [
  {
    path: frontendURL('accounts/:accountId/support-desk'),
    name: 'support_desk',
    component: () => import('./Index.vue'),
    meta: { allowAllAuthenticated: true },
  },
  {
    path: frontendURL('accounts/:accountId/release-announcements'),
    name: 'release_announcements',
    component: () => import('./Index.vue'),
    meta: { allowAllAuthenticated: true },
  },
];
